import { useSelector } from 'react-redux';
// @ts-expect-error not yet migrated
import EditorApprovalProvider from 'ContentEditorUI/components/approvals/EditorApprovalProvider';
import { SuspensionBannersContextProvider, ContextSuspensionBanners
// @ts-expect-error not yet migrated
} from 'ui-suspension-banners-lib';
import { getIsLandingPage, getIsSitePage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
// @ts-expect-error not yet migrated
import { getContentModelName } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-expect-error not yet migrated
import { getApprovalContentId } from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
import { getHasApprovalsReadAccess, getHasApprovalsWriteAccess } from 'page-editor-ui/redux/selectors/authSelectors';
import FixInvalidPageExpiryDateController from './FixInvalidPageExpiryDateController';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExtraApplicationContainerWrapper = ({
  children
}) => {
  const isLandingPage = useSelector(getIsLandingPage);
  const isSitePage = useSelector(getIsSitePage);
  const approvalContentId = useSelector(getApprovalContentId);
  const approvalAssetName = useSelector(getContentModelName);
  const hasReadAccessToProductApprovals = useSelector(getHasApprovalsReadAccess);
  const hasWriteAccessToProductApprovals = useSelector(getHasApprovalsWriteAccess);
  return /*#__PURE__*/_jsx(EditorApprovalProvider, {
    approvalType: isLandingPage ? 'LANDING_PAGE' : isSitePage ? 'SITE_PAGE' : undefined,
    restartOnConclude: isSitePage || isLandingPage,
    hasReadAccessToProductApprovals: hasReadAccessToProductApprovals,
    hasWriteAccessToProductApprovals: hasWriteAccessToProductApprovals,
    contentId: approvalContentId,
    assetName: approvalAssetName,
    children: /*#__PURE__*/_jsxs(SuspensionBannersContextProvider, {
      children: [/*#__PURE__*/_jsx(ContextSuspensionBanners, {
        scope: "landingpages-trusted",
        source: isLandingPage ? 'LANDING_PAGES' : 'SITE_PAGES'
      }), /*#__PURE__*/_jsx(FixInvalidPageExpiryDateController, {}), children]
    })
  });
};
export default ExtraApplicationContainerWrapper;